import {
    INFRA_LOGBOOK_LIST,
    INFRA_LOGBOOK_LIST_SUCCESS,
    INFRA_LOGBOOK_LIST_ERROR,
    INFRA_LOGBOOK_PAGE_SET,
    INFRA_LOGBOOK_SEARCH_CHANGE,
    INFRA_LOGBOOK_ADD_MODAL_SET,
    INFRA_LOGBOOK_ADD_CHANGE,
    INFRA_LOGBOOK_ADD,
    INFRA_LOGBOOK_ADD_SUCCESS,
    INFRA_LOGBOOK_ADD_ERROR,
    INFRA_LOGBOOK_EDIT_MODAL_SET,
    INFRA_LOGBOOK_EDIT_SET_DATA,
    INFRA_LOGBOOK_UPDATE,
    INFRA_LOGBOOK_UPDATE_SUCCESS,
    INFRA_LOGBOOK_UPDATE_ERROR,
    INFRA_LOGBOOK_CONTRACT_ERP_DATA,
    INFRA_LOGBOOK_CONTRACT_ERP_DATA_SUCCESS,
    INFRA_LOGBOOK_CONTRACT_ERP_DATA_ERROR,
    INFRA_LOGBOOK_SAVE_CONTRACT,
    INFRA_LOGBOOK_SAVE_CONTRACT_SUCCESS,
    INFRA_LOGBOOK_SAVE_CONTRACT_ERROR,
    INFRA_LOGBOOK_UPDATE_CONTRACT_NOTES,
    INFRA_LOGBOOK_UPDATE_CONTRACT_NOTES_SUCCESS,
    INFRA_LOGBOOK_UPDATE_CONTRACT_NOTES_ERROR,
} from '../../actions';

const INIT_FORM = {
    id_logbook: null,
    id_contract_logbook: null,
    logbook_date: '',
    activity: '',
    description: '',
    notes: ''
};

const INIT_STATE = {
    list: { loading: false, data: [], error: null },
    page: 1,
    num_page: 10,
    orderBy: null,
    filters: {},
    search: '',
    contractERPData: { loading: false, searched: false, data: [], error: null },
    saveContract: { loading: false, success: false, data: null, error: null },
    updateContractNotes: { loading: false, error: null },
    updateContractSummary: { loading: false, error: null },
    add: { modal: false, loading: false, error: null, data: { ...INIT_FORM } },
    edit: { modal: false, loading: false, data: { ...INIT_FORM } }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case INFRA_LOGBOOK_LIST:
            return { ...state, list: { ...state.list, loading: true, error: null } };
        case INFRA_LOGBOOK_LIST_SUCCESS:
            return { ...state, list: { loading: false, data: action.payload.data || [], error: null } };
        case INFRA_LOGBOOK_LIST_ERROR:
            return { ...state, list: { ...state.list, loading: false, error: action.payload } };
        case INFRA_LOGBOOK_PAGE_SET:
            return { ...state, page: action.payload };
        case INFRA_LOGBOOK_SEARCH_CHANGE:
            return { ...state, search: action.payload };
        case INFRA_LOGBOOK_CONTRACT_ERP_DATA:
            return {
                ...state,
                contractERPData: { loading: true, searched: false, data: [], error: null },
                saveContract: { loading: false, success: false, data: null, error: null }
            };
        case INFRA_LOGBOOK_CONTRACT_ERP_DATA_SUCCESS:
            return { ...state, contractERPData: { loading: false, searched: true, data: action.payload || [], error: null } };
        case INFRA_LOGBOOK_CONTRACT_ERP_DATA_ERROR:
            return { ...state, contractERPData: { loading: false, searched: true, data: [], error: action.payload } };
        case INFRA_LOGBOOK_SAVE_CONTRACT:
            return { ...state, saveContract: { loading: true, success: false, data: null, error: null } };
        case INFRA_LOGBOOK_SAVE_CONTRACT_SUCCESS:
            return { ...state, saveContract: { loading: false, success: true, data: action.payload, error: null } };
        case INFRA_LOGBOOK_SAVE_CONTRACT_ERROR:
            return { ...state, saveContract: { loading: false, success: false, data: null, error: action.payload } };
        case INFRA_LOGBOOK_UPDATE_CONTRACT_NOTES: {
            const stateKey = action.payload.field === 'summary' ? 'updateContractSummary' : 'updateContractNotes';
            return { ...state, [stateKey]: { loading: true, error: null } };
        }
        case INFRA_LOGBOOK_UPDATE_CONTRACT_NOTES_SUCCESS: {
            const stateKey = action.payload.field === 'summary' ? 'updateContractSummary' : 'updateContractNotes';
            return { ...state, [stateKey]: { loading: false, error: null } };
        }
        case INFRA_LOGBOOK_UPDATE_CONTRACT_NOTES_ERROR: {
            const stateKey = action.payload.field === 'summary' ? 'updateContractSummary' : 'updateContractNotes';
            return { ...state, [stateKey]: { loading: false, error: action.payload.error } };
        }

        case INFRA_LOGBOOK_ADD_MODAL_SET:
            return {
                ...state,
                add: action.payload && action.payload.open
                    ? { ...state.add, modal: true, error: null, data: { ...INIT_FORM, ...(action.payload.data || {}) } }
                    : { ...state.add, modal: false, error: null, data: { ...INIT_FORM } }
            };
        case INFRA_LOGBOOK_ADD_CHANGE:
            return { ...state, add: { ...state.add, data: { ...state.add.data, ...action.payload } } };
        case INFRA_LOGBOOK_ADD:
            return { ...state, add: { ...state.add, loading: true, error: null } };
        case INFRA_LOGBOOK_ADD_SUCCESS:
                if (action.payload && action.payload.isFollowUpAction) {
                    const newEntry = action.payload.entry || {};
                    const documents = (newEntry.files || []).map((file) => ({
                        document_name: file.name,
                        original_document_name: file.original || file.name,
                        url_document: file.url
                    }));
                    return {
                        ...state,
                        add: {
                            ...state.add,
                            loading: false,
                            error: null,
                            data: {
                                ...state.add.data,
                                summaryNeedsRefresh: true,
                                logbook_entries: [
                                    ...(Array.isArray(state.add.data.logbook_entries) ? state.add.data.logbook_entries : []),
                                    {
                                        id_logbook: action.payload.id,
                                        id_contract_logbook: newEntry.id_contract_logbook,
                                        logbook_date: newEntry.logbook_date,
                                        activity: newEntry.activity,
                                        description: newEntry.description,
                                        notes: newEntry.notes,
                                        documents
                                    }
                                ]
                            }
                        }
                    };
                }
            return { ...state, add: { ...state.add, loading: false, modal: false, error: null, data: { ...INIT_FORM } } };
        case INFRA_LOGBOOK_ADD_ERROR:
            return { ...state, add: { ...state.add, loading: false, error: action.payload } };

        case INFRA_LOGBOOK_EDIT_MODAL_SET:
            return {
                ...state,
                edit: action.payload && action.payload.open
                    ? { ...state.edit, modal: true, data: { ...INIT_FORM, ...(action.payload.data || {}) } }
                    : { ...state.edit, modal: false, data: { ...INIT_FORM } }
            };
        case INFRA_LOGBOOK_EDIT_SET_DATA:
            return { ...state, edit: { ...state.edit, data: { ...state.edit.data, ...action.payload } } };
        case INFRA_LOGBOOK_UPDATE:
            return { ...state, edit: { ...state.edit, loading: true } };
        case INFRA_LOGBOOK_UPDATE_SUCCESS:
            return { ...state, edit: { ...state.edit, loading: false, modal: false, data: { ...INIT_FORM } } };
        case INFRA_LOGBOOK_UPDATE_ERROR:
            return { ...state, edit: { ...state.edit, loading: false } };

        default:
            return state;
    }
};